/* Generated File DO NOT EDIT. */
/* tslint:disable */
import * as Types from '../graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AchievementQueryVariables = Types.Exact<{ [key: string]: never }>;

export type AchievementQuery = {
  __typename?: 'Query';
  historicalActivities: Array<{ __typename?: 'Activity'; _id: string; weekOf: string; schedule: Array<{ __typename?: 'DayAndPeriod'; day: string; period: Array<string>; completed: Array<Types.CompletionStatus> }> }>;
  positiveMood: Array<{ __typename?: 'QuestionAnswer'; answeredAt?: any | null; response: string }>;
  negativeMood: Array<{ __typename?: 'QuestionAnswer'; answeredAt?: any | null; response: string }>;
  motivation: Array<{ __typename?: 'QuestionAnswer'; answeredAt?: any | null; response: string }>;
};

export const AchievementDocument = gql`
  query achievement {
    historicalActivities {
      _id
      weekOf
      schedule {
        day
        period
        completed
      }
    }
    positiveMood: getDailyAnswers(type: PositiveMood) {
      answeredAt
      response
    }
    negativeMood: getDailyAnswers(type: NegativeMood) {
      answeredAt
      response
    }
    motivation: getWeeklyLogsAnswers {
      answeredAt
      response
    }
  }
`;

/**
 * __useAchievementQuery__
 *
 * To run a query within a React component, call `useAchievementQuery` and pass it any options that fit your needs.
 * When your component renders, `useAchievementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAchievementQuery({
 *   variables: {
 *   },
 * });
 */
export function useAchievementQuery(baseOptions?: Apollo.QueryHookOptions<AchievementQuery, AchievementQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AchievementQuery, AchievementQueryVariables>(AchievementDocument, options);
}
export function useAchievementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AchievementQuery, AchievementQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AchievementQuery, AchievementQueryVariables>(AchievementDocument, options);
}
export type AchievementQueryHookResult = ReturnType<typeof useAchievementQuery>;
export type AchievementLazyQueryHookResult = ReturnType<typeof useAchievementLazyQuery>;
export type AchievementQueryResult = Apollo.QueryResult<AchievementQuery, AchievementQueryVariables>;
